import * as React from "react";
import { cn } from "../../lib/utils";

const Input = React.forwardRef(({ className, type, style, onFocus, onBlur, ...props }, ref) => {
  const [focused, setFocused] = React.useState(false);

  return (
    <input
      type={type}
      autoComplete="off"
      className={cn(
        "tw-flex tw-h-11 tw-w-full tw-rounded-xl tw-border tw-border-white/10 tw-bg-white/[0.03] tw-px-4 tw-py-1 tw-text-[14px] tw-text-white tw-transition-colors placeholder:tw-text-muted disabled:tw-cursor-not-allowed disabled:tw-opacity-50",
        className
      )}
      style={{
        boxSizing: "border-box",
        height: 44,
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        padding: "0 16px",
        borderRadius: 12,
        background: "rgba(255,255,255,0.035)",
        border: `1px solid ${focused ? "rgba(0,173,181,0.5)" : "rgba(255,255,255,0.12)"}`,
        // Focus ring is driven by React state, not the focus-visible: Tailwind
        // classes this used to rely on — the sibling inline boxShadow below
        // always wins over a Tailwind class in this codebase, which silently
        // killed the ring and left the browser's native outline free to
        // flash at the (rounded) corners. `outline: none` closes that gap.
        boxShadow: focused
          ? "inset 0 1px 2px rgba(0,0,0,0.15), 0 0 0 3px rgba(0,173,181,0.18)"
          : "inset 0 1px 2px rgba(0,0,0,0.15)",
        outline: "none",
        color: "#fff",
        fontSize: 14,
        transition: "border-color 0.12s ease, box-shadow 0.12s ease",
        ...style,
      }}
      onFocus={(e) => {
        setFocused(true);
        onFocus?.(e);
      }}
      onBlur={(e) => {
        setFocused(false);
        onBlur?.(e);
      }}
      ref={ref}
      {...props}
    />
  );
});
Input.displayName = "Input";

export { Input };
